function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import "jquery.cookie";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Api from "../ajax/SessionApi";
import * as Utility from "../commons/Utility";
import { ReductionStatuses } from "../enum/ReductionStatuses";
import * as SessionQrCodeModalComponentSmartphone from "./SessionQrCodeModalComponentSmartphone";
import { ApiResultCodes } from "../enum/ApiResultCodes";
import * as JsxUtility from "../commons/JsxUtility";
import ReactDatePicker from 'react-datepicker';
import moment from 'moment';
import CustomDateComponent from "./CustomDateComponent";
import IntlMessage from '../commons/Intl';
import { Sessions, ResourceUpload, Errors, Label, Session, Placeholder, Situations, Action, ModifySession, CreateSession, ReadonlySession, SessionHistories, StreamingSituations } from '../commons/IntlMessages';
import { StreamingStatuses } from "../enum/StreamingStatuses";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);
/**
 * 素材リスト
 */

var materialFileList = [];
/**
 * 素材サイズの合計
 */

var totalMaterialFileSize; // 会議管理

/**
 * モード
 */

export var SessionDetailMode;

(function (SessionDetailMode) {
  /**
   * なし
   */
  SessionDetailMode[SessionDetailMode["None"] = 0] = "None";
  /**
   * 追加
   */

  SessionDetailMode[SessionDetailMode["Add"] = 1] = "Add";
  /**
   * 更新
   */

  SessionDetailMode[SessionDetailMode["Modify"] = 2] = "Modify";
  /**
   * 表示のみ
   */

  SessionDetailMode[SessionDetailMode["ReadOnly"] = 4] = "ReadOnly";
})(SessionDetailMode || (SessionDetailMode = {}));
/**
 * 会議詳細コンポーネント
 */


var SessionDetailComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(SessionDetailComponent, _React$Component);

  var _super = _createSuper(SessionDetailComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function SessionDetailComponent(props) {
    var _this;

    _classCallCheck(this, SessionDetailComponent);

    _this = _super.call(this, props);
    var nowStart = moment().startOf('minutes');
    var nowEnd = nowStart.clone().add('hours', 1);

    switch (props.mode) {
      case SessionDetailMode.Add:
        _this.state = {
          SessionName: _this.props.sessionName,
          StartDate: _this.props.startDate != null ? _this.props.startDate : nowStart,
          StartTimeHours: _this.props.startTimeHours != null ? _this.props.startTimeHours : nowStart.hours(),
          StartTimeMinutes: _this.props.startTimeMinutes != null ? _this.props.startTimeMinutes : nowStart.minutes(),
          EndDate: _this.props.endDate != null ? _this.props.endDate : nowEnd,
          EndTimeHours: _this.props.endTimeHours != null ? _this.props.endTimeHours : nowEnd.hours(),
          EndTimeMinutes: _this.props.endTimeMinutes != null ? _this.props.endTimeMinutes : nowEnd.minutes(),
          SceneModelName: _this.props.sceneModelName,
          SceneImageName: _this.props.sceneImageName,
          ErrorMessages: []
        };
        break;

      case SessionDetailMode.Modify:
        if (_this.props.startDateTime == null || _this.props.endDateTime == null) {
          throw Error();
        }

        _this.state = {
          SessionName: _this.props.sessionName,
          StartDate: _this.props.startDate != null ? _this.props.startDate : Utility.ToMoment(_this.props.startDateTime),
          StartTimeHours: _this.props.startTimeHours != null ? _this.props.startTimeHours : Number(Utility.ToMoment(_this.props.startDateTime).format("HH")),
          StartTimeMinutes: _this.props.startTimeMinutes != null ? _this.props.startTimeMinutes : Number(Utility.ToMoment(_this.props.startDateTime).format("mm")),
          EndDate: _this.props.endDate != null ? _this.props.endDate : Utility.ToMoment(_this.props.endDateTime),
          EndTimeHours: _this.props.endTimeHours != null ? _this.props.endTimeHours : Number(Utility.ToMoment(_this.props.endDateTime).format("HH")),
          EndTimeMinutes: _this.props.endTimeMinutes != null ? _this.props.endTimeMinutes : Number(Utility.ToMoment(_this.props.endDateTime).format("mm")),
          SceneModelName: _this.props.sceneModelName,
          SceneImageName: _this.props.sceneImageName,
          ErrorMessages: []
        };
        break;

      case SessionDetailMode.ReadOnly:
        if (!_this.props.startDateTime || !_this.props.endDateTime) {
          throw Error();
        }

        _this.state = {
          SessionName: _this.props.sessionName,
          StartDate: _this.props.startDate != null ? _this.props.startDate : Utility.ToMoment(_this.props.startDateTime),
          StartTimeHours: _this.props.startTimeHours != null ? _this.props.startTimeHours : Number(Utility.ToMoment(_this.props.startDateTime).format("HH")),
          StartTimeMinutes: _this.props.startTimeMinutes != null ? _this.props.startTimeMinutes : Number(Utility.ToMoment(_this.props.startDateTime).format("mm")),
          EndDate: _this.props.endDate != null ? _this.props.endDate : Utility.ToMoment(_this.props.endDateTime),
          EndTimeHours: _this.props.endTimeHours != null ? _this.props.endTimeHours : Number(Utility.ToMoment(_this.props.endDateTime).format("HH")),
          EndTimeMinutes: _this.props.endTimeMinutes != null ? _this.props.endTimeMinutes : Number(Utility.ToMoment(_this.props.endDateTime).format("mm")),
          SceneModelName: _this.props.sceneModelName,
          SceneImageName: _this.props.sceneImageName,
          ErrorMessages: []
        };
        break;

      default:
        throw Error;
    }

    _this.onCloseFunction = _this.onClose.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * 会議名を更新します。
   *
   * @param e イベント
   */


  _createClass(SessionDetailComponent, [{
    key: "updateSessionName",
    value: function updateSessionName(e) {
      this.setState({
        SessionName: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * 開始日を更新します。
     *
     * @param d 開始日
     */

  }, {
    key: "updateStartDate",
    value: function updateStartDate(d) {
      var currentStartDateTime = moment(Utility.parseMoment(this.state.StartDate, this.state.StartTimeHours, this.state.StartTimeMinutes));
      var currentEndDateTime = moment(Utility.parseMoment(this.state.EndDate, this.state.EndTimeHours, this.state.EndTimeMinutes));
      var diff = currentEndDateTime.diff(currentStartDateTime, 'milliseconds');
      var startDateTime = moment(Utility.parseMoment(d, this.state.StartTimeHours, this.state.StartTimeMinutes));
      var endDateTime = startDateTime.clone().add('milliseconds', diff);
      this.setState({
        StartDate: d,
        EndDate: endDateTime,
        EndTimeHours: endDateTime.hours(),
        EndTimeMinutes: endDateTime.minutes()
      });
    }
    /**
     * 開始時刻（時）を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateStartTimeHours",
    value: function updateStartTimeHours(e) {
      var startHour = Number(e.target.value);
      if (startHour > 23) startHour = 0;else if (startHour < 0) startHour = 23;
      var currentStartDateTime = moment(Utility.parseMoment(this.state.StartDate, this.state.StartTimeHours, this.state.StartTimeMinutes));
      var currentEndDateTime = moment(Utility.parseMoment(this.state.EndDate, this.state.EndTimeHours, this.state.EndTimeMinutes));
      var diff = currentEndDateTime.diff(currentStartDateTime, 'milliseconds');
      var startDateTime = moment(Utility.parseMoment(this.state.StartDate, startHour, this.state.StartTimeMinutes));
      var endDateTime = startDateTime.clone().add('milliseconds', diff);
      this.setState({
        StartTimeHours: startHour,
        EndDate: endDateTime,
        EndTimeHours: endDateTime.hours(),
        EndTimeMinutes: endDateTime.minutes()
      });
    }
    /**
     * 開始時刻（分）を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateStartTimeMinutes",
    value: function updateStartTimeMinutes(e) {
      var startMin = Number(e.target.value);
      if (startMin > 59) startMin = 0;else if (startMin < 0) startMin = 59;
      var currentStartDateTime = moment(Utility.parseMoment(this.state.StartDate, this.state.StartTimeHours, this.state.StartTimeMinutes));
      var currentEndDateTime = moment(Utility.parseMoment(this.state.EndDate, this.state.EndTimeHours, this.state.EndTimeMinutes));
      var diff = currentEndDateTime.diff(currentStartDateTime, 'milliseconds');
      var startDateTime = moment(Utility.parseMoment(this.state.StartDate, this.state.StartTimeHours, startMin));
      var endDateTime = startDateTime.clone().add('milliseconds', diff);
      this.setState({
        StartTimeMinutes: startMin,
        EndDate: endDateTime,
        EndTimeHours: endDateTime.hours(),
        EndTimeMinutes: endDateTime.minutes()
      });
    }
    /**
     * 終了日を更新します。
     *
     * @param d 終了日
     */

  }, {
    key: "updateEndDate",
    value: function updateEndDate(d) {
      this.setState({
        EndDate: d
      });
    }
    /**
     * 終了時刻（時）を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateEndTimeHours",
    value: function updateEndTimeHours(e) {
      var endHour = Number(e.target.value);
      if (endHour > 23) endHour = 0;else if (endHour < 0) endHour = 23;
      this.setState({
        EndTimeHours: endHour
      });
    }
    /**
     * 終了時刻（分）を更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateEndTimeMinutes",
    value: function updateEndTimeMinutes(e) {
      var endMin = Number(e.target.value);
      if (endMin > 59) endMin = 0;else if (endMin < 0) endMin = 59;
      this.setState({
        EndTimeMinutes: endMin
      });
    }
    /**
     * 「登録」ボタン押下時の処理を行います。
     */

  }, {
    key: "onEntry",
    value: function onEntry() {
      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        this.state.ErrorMessages.length = 0;
        var startDateTime = Utility.parseMoment(this.state.StartDate, this.state.StartTimeHours, this.state.StartTimeMinutes);
        var endDateTime = Utility.parseMoment(this.state.EndDate, this.state.EndTimeHours, this.state.EndTimeMinutes); // 過去の時刻が設定されていたら現在時刻にする

        var currentDate = moment().startOf('minutes');

        if (moment(startDateTime).diff(currentDate) <= 0) {
          startDateTime = currentDate.toDate();
        }

        if (moment(endDateTime).diff(moment(startDateTime)) <= 0) {
          this.state.ErrorMessages.push(intl.format(Errors.InputPariod));
        }

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        this.props.onEntry(this.state.SessionName, startDateTime, endDateTime, this.state.SceneModelName, this.state.SceneImageName, this.props.targetFolderName);
        this.props.onHidden();
      }
    }
    /**
     * 「更新」ボタン押下時の処理を行います。
     */

  }, {
    key: "onModify",
    value: function onModify() {
      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        this.state.ErrorMessages.length = 0;
        var currentDate = moment().startOf('minutes');
        var beforeStartDateTime = this.props.startDateTime != null ? this.props.startDateTime : currentDate.toDate();
        var startDateTime = Utility.parseMoment(this.state.StartDate, this.state.StartTimeHours, this.state.StartTimeMinutes);
        var endDateTime = Utility.parseMoment(this.state.EndDate, this.state.EndTimeHours, this.state.EndTimeMinutes);
        if (moment(startDateTime).diff(currentDate, "minutes") < 0 && moment(startDateTime).diff(moment(beforeStartDateTime), "minutes") != 0) this.state.ErrorMessages.push(intl.format(Errors.InputPastStartDate));else if (moment(endDateTime).diff(currentDate, "minutes") < 0) this.state.ErrorMessages.push(intl.format(Errors.InputPastEndDate));else if (moment(endDateTime).diff(moment(startDateTime), "minutes") <= 0) this.state.ErrorMessages.push(intl.format(Errors.InputPariod));

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        if (!this.props.sessionId || !this.props.updateDateTime) {
          throw Error();
        }

        this.props.onModify(this.props.sessionId, this.state.SessionName, startDateTime, endDateTime, this.state.SceneModelName, this.state.SceneImageName, this.props.updateDateTime);
        this.props.onHidden();
      }
    }
    /**
     * 「閉じる」ボタン押下時の処理を行います。
     */

  }, {
    key: "onClose",
    value: function onClose() {
      this.props.onHidden();
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.scrollTo(0, 0);
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
      var backButton = $("#menuReactBack");
      backButton.css("display", "block");
      backButton.on("click", this.onCloseFunction);
    }
    /**
     * ComponentがDOMツリーから削除された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var backButton = $("#menuReactBack");
      backButton.css("display", "none");
      backButton.off("click", this.onCloseFunction);
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "SessionDetail"
      }, /*#__PURE__*/React.createElement("div", {
        className: "main"
      }, /*#__PURE__*/React.createElement("div", {
        className: "main-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "main-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "mainIcon",
        width: "40",
        height: "42",
        src: "/assets/img/Icon_SessionManagement_Gray.svg"
      }), this.props.mode == SessionDetailMode.Add && /*#__PURE__*/React.createElement("h1", null, intl.format(CreateSession.Title)), this.props.mode == SessionDetailMode.Modify && /*#__PURE__*/React.createElement("h1", null, intl.format(ModifySession.Title)), this.props.mode == SessionDetailMode.ReadOnly && /*#__PURE__*/React.createElement("h1", null, intl.format(ReadonlySession.Title)))), /*#__PURE__*/React.createElement("div", {
        className: "main-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "SessionName"
      }, intl.format(Label.Name)), this.props.mode != SessionDetailMode.ReadOnly && /*#__PURE__*/React.createElement("div", {
        className: "col-11"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "SessionName",
        id: "SessionName",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        maxLength: 40,
        onChange: function onChange(e) {
          return _this2.updateSessionName(e);
        },
        value: this.state.SessionName,
        tabIndex: 101,
        placeholder: intl.format(Placeholder.Letters, {
          value: "40"
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "SessionName",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      })), this.props.mode == SessionDetailMode.ReadOnly && /*#__PURE__*/React.createElement("div", {
        className: "col-11"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        name: "SessionName",
        id: "SessionName",
        readOnly: true,
        value: this.state.SessionName,
        tabIndex: 101
      }))), /*#__PURE__*/React.createElement("div", {
        className: "start-end-date-label"
      }, intl.format(SessionHistories.TimeAndDate)), /*#__PURE__*/React.createElement("div", {
        className: "form-group row form-group-startdate"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "StartDate"
      }, intl.format(Label.StartDate)), this.props.mode != SessionDetailMode.ReadOnly && [/*#__PURE__*/React.createElement("div", {
        className: "date row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-6"
      }, /*#__PURE__*/React.createElement(ReactDatePicker, {
        customInput: /*#__PURE__*/React.createElement(CustomDateComponent, null),
        name: "StartDate",
        id: "StartDate",
        tabIndex: 103,
        selected: this.state.StartDate,
        onChange: this.updateStartDate.bind(this),
        dateFormat: "YYYY/M/D",
        locale: "ja",
        showMonthDropdown: true,
        showYearDropdown: true,
        dropdownMode: "select"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-3 moment-dropdown-group"
      }, /*#__PURE__*/React.createElement("input", {
        name: "StartTimeHours_Input",
        className: "moment-input",
        type: "number",
        value: Utility.NullNumberToBlank(this.state.StartTimeHours).padStart(2, "0"),
        onChange: this.updateStartTimeHours.bind(this)
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default dropdown-toggle moment-btn-dropdown",
        "data-toggle": "dropdown",
        "aria-expanded": "false"
      }, /*#__PURE__*/React.createElement("span", {
        className: "caret"
      })), /*#__PURE__*/React.createElement("ul", {
        className: "dropdown-menu moment-dropdown-menu"
      }, JsxUtility.CreateHoursListItems(this.updateStartTimeHours.bind(this)))), /*#__PURE__*/React.createElement("div", {
        className: "col-3 moment-dropdown-group"
      }, /*#__PURE__*/React.createElement("input", {
        name: "StartTimeMinutes_Input",
        className: "moment-input",
        type: "number",
        value: Utility.NullNumberToBlank(this.state.StartTimeMinutes).padStart(2, "0"),
        onChange: this.updateStartTimeMinutes.bind(this)
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default dropdown-toggle moment-btn-dropdown",
        "data-toggle": "dropdown",
        "aria-expanded": "false"
      }, /*#__PURE__*/React.createElement("span", {
        className: "caret"
      })), /*#__PURE__*/React.createElement("ul", {
        className: "dropdown-menu moment-dropdown-menu"
      }, JsxUtility.CreateUnitsOf15MinutesListItems(this.updateStartTimeMinutes.bind(this)))))], this.props.mode == SessionDetailMode.ReadOnly && /*#__PURE__*/React.createElement("div", {
        className: "date row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-6"
      }, /*#__PURE__*/React.createElement(ReactDatePicker, {
        customInput: /*#__PURE__*/React.createElement(CustomDateComponent, null),
        name: "StartDate",
        id: "StartDate",
        disabled: true,
        tabIndex: 103,
        selected: this.state.StartDate,
        onChange: this.updateStartDate.bind(this),
        dateFormat: "YYYY/M/D",
        locale: "ja"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-3 moment-dropdown-group"
      }, /*#__PURE__*/React.createElement("input", {
        name: "StartTimeHours_Input",
        className: "moment-input",
        type: "number",
        disabled: true,
        value: Utility.NullNumberToBlank(this.state.StartTimeHours).padStart(2, "0"),
        style: {
          backgroundColor: "#e9ecef",
          opacity: "1"
        }
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        disabled: true,
        className: "btn btn-default dropdown-toggle moment-btn-dropdown",
        style: {
          cursor: "default"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "caret"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-3 moment-dropdown-group"
      }, /*#__PURE__*/React.createElement("input", {
        name: "StartTimeMinutes_Input",
        className: "moment-input",
        type: "number",
        disabled: true,
        value: Utility.NullNumberToBlank(this.state.StartTimeMinutes).padStart(2, "0"),
        style: {
          backgroundColor: "#e9ecef",
          opacity: "1"
        }
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        disabled: true,
        className: "btn btn-default dropdown-toggle moment-btn-dropdown",
        style: {
          cursor: "default"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "caret"
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row form-group-enddate"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "EndDate"
      }, intl.format(Label.EndDate)), this.props.mode != SessionDetailMode.ReadOnly && /*#__PURE__*/React.createElement("div", {
        className: "date row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-6"
      }, /*#__PURE__*/React.createElement(ReactDatePicker, {
        customInput: /*#__PURE__*/React.createElement(CustomDateComponent, null),
        name: "EndDate",
        id: "EndDate",
        tabIndex: 104,
        selected: this.state.EndDate,
        onChange: this.updateEndDate.bind(this),
        dateFormat: "YYYY/M/D",
        locale: "ja",
        showMonthDropdown: true,
        showYearDropdown: true,
        dropdownMode: "select"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-3 moment-dropdown-group"
      }, /*#__PURE__*/React.createElement("input", {
        name: "EndTimeHours_Input",
        className: "moment-input",
        type: "number",
        value: Utility.NullNumberToBlank(this.state.EndTimeHours).padStart(2, "0"),
        onChange: this.updateEndTimeHours.bind(this)
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default dropdown-toggle moment-btn-dropdown",
        "data-toggle": "dropdown",
        "aria-expanded": "false"
      }, /*#__PURE__*/React.createElement("span", {
        className: "caret"
      })), /*#__PURE__*/React.createElement("ul", {
        className: "dropdown-menu moment-dropdown-menu"
      }, JsxUtility.CreateHoursListItems(this.updateEndTimeHours.bind(this)))), /*#__PURE__*/React.createElement("div", {
        className: "col-3 moment-dropdown-group"
      }, /*#__PURE__*/React.createElement("input", {
        name: "EndTimeMinutes_Input",
        className: "moment-input",
        type: "number",
        value: Utility.NullNumberToBlank(this.state.EndTimeMinutes).padStart(2, "0"),
        onChange: this.updateEndTimeMinutes.bind(this)
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default dropdown-toggle moment-btn-dropdown",
        "data-toggle": "dropdown",
        "aria-expanded": "false"
      }, /*#__PURE__*/React.createElement("span", {
        className: "caret"
      })), /*#__PURE__*/React.createElement("ul", {
        className: "dropdown-menu moment-dropdown-menu"
      }, JsxUtility.CreateUnitsOf15MinutesListItems(this.updateEndTimeMinutes.bind(this))))), this.props.mode == SessionDetailMode.ReadOnly && /*#__PURE__*/React.createElement("div", {
        className: "date row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-6"
      }, /*#__PURE__*/React.createElement(ReactDatePicker, {
        customInput: /*#__PURE__*/React.createElement(CustomDateComponent, null),
        name: "EndDate",
        id: "EndDate",
        disabled: true,
        tabIndex: 104,
        selected: this.state.EndDate,
        onChange: this.updateEndDate.bind(this),
        dateFormat: "YYYY/M/D",
        locale: "ja"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-3 moment-dropdown-group"
      }, /*#__PURE__*/React.createElement("input", {
        name: "EndTimeHours_Input",
        className: "moment-input",
        type: "number",
        disabled: true,
        value: Utility.NullNumberToBlank(this.state.EndTimeHours).padStart(2, "0"),
        style: {
          backgroundColor: "#e9ecef",
          opacity: "1"
        }
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        disabled: true,
        className: "btn btn-default dropdown-toggle moment-btn-dropdown",
        style: {
          cursor: "default"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "caret"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-3 moment-dropdown-group"
      }, /*#__PURE__*/React.createElement("input", {
        name: "EndTimeMinutes_Input",
        className: "moment-input",
        type: "number",
        disabled: true,
        value: Utility.NullNumberToBlank(this.state.EndTimeMinutes).padStart(2, "0"),
        style: {
          backgroundColor: "#e9ecef",
          opacity: "1"
        }
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        disabled: true,
        className: "btn btn-default dropdown-toggle moment-btn-dropdown",
        style: {
          cursor: "default"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "caret"
      })))))), this.props.mode == SessionDetailMode.Add && /*#__PURE__*/React.createElement("div", {
        className: "main-footer"
      }, /*#__PURE__*/React.createElement("button", {
        key: "button",
        type: "button",
        className: "btn btn-outline-primary",
        onClick: this.onClose.bind(this),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "buttonIcon",
        src: "/assets/img/cross.svg"
      }), /*#__PURE__*/React.createElement("div", null, intl.format(Action.CancelAdd))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onEntry.bind(this),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "buttonIcon",
        src: "/assets/img/floppy_disk.svg"
      }), /*#__PURE__*/React.createElement("div", null, intl.format(Action.RegisterContent)))), this.props.mode == SessionDetailMode.Modify && /*#__PURE__*/React.createElement("div", {
        className: "main-footer"
      }, /*#__PURE__*/React.createElement("button", {
        key: "button",
        type: "button",
        className: "btn btn-outline-primary",
        onClick: this.onClose.bind(this),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "buttonIcon",
        src: "/assets/img/cross.svg"
      }), /*#__PURE__*/React.createElement("div", null, intl.format(Action.CancelEdit))), /*#__PURE__*/React.createElement("button", {
        key: "onModify",
        type: "button",
        className: "btn btn-primary",
        onClick: this.onModify.bind(this),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "buttonIcon",
        src: "/assets/img/floppy_disk.svg"
      }), /*#__PURE__*/React.createElement("div", null, intl.format(Action.RegisterContent)))), this.props.mode == SessionDetailMode.ReadOnly && /*#__PURE__*/React.createElement("div", {
        className: "main-footer"
      }, /*#__PURE__*/React.createElement("button", {
        key: "button",
        type: "button",
        className: "btn btn-outline-primary",
        onClick: this.onClose.bind(this),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "buttonIcon",
        src: "/assets/img/cross.svg"
      }), /*#__PURE__*/React.createElement("div", null, intl.format(Action.Close))))));
    }
  }]);

  return SessionDetailComponent;
}(React.Component);
/**
 * メインコンポーネント
 */


var FileListComponent = /*#__PURE__*/function (_React$Component2) {
  _inherits(FileListComponent, _React$Component2);

  var _super2 = _createSuper(FileListComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function FileListComponent(props) {
    var _this3;

    _classCallCheck(this, FileListComponent);

    _this3 = _super2.call(this, props);
    _this3.state = {
      QrCodeModalMode: SessionQrCodeModalComponentSmartphone.Mode.None
    };
    _this3.onCloseFunction = _this3.onClose.bind(_assertThisInitialized(_this3));
    return _this3;
  }
  /**
   * 「閉じる」ボタン押下時の処理を行います。
   */


  _createClass(FileListComponent, [{
    key: "onClose",
    value: function onClose() {
      this.props.onHidden();
    }
    /**
     * ファイルアップロードボタン押下時の処理を行います。
     */

  }, {
    key: "fileupload",
    value: function fileupload() {
      this.$file.click();
    }
    /**
     * 整形された日付を取得します。
     *
     * @param date 日付
     */

  }, {
    key: "getFormattedDate",
    value: function getFormattedDate(model) {
      return Utility.ToMoment(model.LastModified).format("YYYY-MM-DD HH:mm:ss");
    }
    /**
     * ステータス名を取得します。
     *
     * @param status ステータス
     */

  }, {
    key: "getReductionStatusName",
    value: function getReductionStatusName(model) {
      if (model.MaterialFileExtension.toLowerCase() == ".stream") {
        switch (model.StreamingStatus) {
          case StreamingStatuses.Offline:
            return intl.format(StreamingSituations.Offline);

          case StreamingStatuses.Live:
            return intl.format(StreamingSituations.Live);

          case StreamingStatuses.Archive:
            return intl.format(StreamingSituations.Archive);

          default:
            throw Error();
        }
      } else {
        switch (model.Status) {
          case ReductionStatuses.Untreated:
            return intl.format(Situations.Success);

          case ReductionStatuses.Cancel:
            return intl.format(Situations.Cancel);

          case ReductionStatuses.Failure:
            return intl.format(Situations.Failure);

          case ReductionStatuses.Processing:
            return intl.format(Situations.Processing);

          case ReductionStatuses.Success:
            return intl.format(Situations.Success);

          case ReductionStatuses.Wait:
            return intl.format(Situations.Wait);

          default:
            throw Error();
        }
      }
    }
    /**
     * リダクション後のサイズを取得します。
     *
     * @param size ステータス
     */

  }, {
    key: "getReductionSize",
    value: function getReductionSize(model) {
      if (!this.props.selected) {
        throw Error();
      }

      if (model.Status == ReductionStatuses.Success) {
        var _model$ReductionMater;

        return this.displayFileSize(((_model$ReductionMater = model.ReductionMaterialFileSize) !== null && _model$ReductionMater !== void 0 ? _model$ReductionMater : 0) * 1024);
      } else {
        return this.displayFileSize(model.MaterialFileSize * 1024);
      }
    }
    /**
     * 表示用ファイルサイズを返却します
     *
     * @param fileSize ファイルサイズ
     */

  }, {
    key: "displayFileSize",
    value: function displayFileSize(sizeInBytes) {
      var sizeInKilobytes = sizeInBytes / 1024;
      var sizeInMegabytes = sizeInKilobytes / 1024;
      var sizeInGigabytes = sizeInMegabytes / 1024;

      if (sizeInBytes < 1024) {
        return "".concat(sizeInBytes.toFixed(1), " B");
      } else if (sizeInKilobytes < 1024) {
        return "".concat(sizeInKilobytes.toFixed(1), " KB");
      } else if (sizeInMegabytes < 1024) {
        return "".concat(sizeInMegabytes.toFixed(2), " MB");
      } else {
        return "".concat(sizeInGigabytes.toFixed(2), " GB");
      }
    }
    /**
     * 選択中の素材が削除可能か判断します。
     */

  }, {
    key: "canDeleteMaterial",
    value: function canDeleteMaterial() {
      if (!this.props.selected) {
        return false;
      }

      if (!this.props.selected.IsMyMeeting) {
        return false;
      }

      if (this.props.selected.SelectedFileNames.length == 0) {
        return false;
      }

      var result = true;

      for (var i = 0; i < this.props.selected.Detail.MaterialList.length; i++) {
        var m = this.props.selected.Detail.MaterialList[i];

        if (this.props.selected.SelectedFileNames.filter(function (x, _i) {
          return x == m.MaterialFileName;
        }).length > 0) {
          if (m.Status == ReductionStatuses.Wait || m.Status == ReductionStatuses.Processing) {
            result = false;
            break;
          }
        }
      }

      return result;
    }
    /**
     * QRコードモーダルを起動します。
     */

  }, {
    key: "openQrCodeModal",
    value: function openQrCodeModal() {
      this.props.onChangeProcessing(true);
      this.props.onClearErrorMessages();
      this.setState({
        QrCodeModalMode: SessionQrCodeModalComponentSmartphone.Mode.ReadOnly
      });
    }
    /**
     * QRコードモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenQrCodeModal",
    value: function hiddenQrCodeModal() {
      this.props.onChangeProcessing(false);
      this.setState({
        QrCodeModalMode: SessionQrCodeModalComponentSmartphone.Mode.None
      });
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;

      var backButton = $("#menuReactBack");
      backButton.css("display", "block");
      backButton.on("click", this.onCloseFunction);
      this.$file = $("#UploadMaterial");
      this.$file.fileupload({
        add: function add(_e, data) {
          var uploadWarning = [];
          var uploadErrors = [];

          for (var i = 0; i < data.originalFiles.length; i++) {
            var material = data.originalFiles[i]; // $MEMO: ファイル名をTrimする

            var materialFileName = "";

            if (material) {
              materialFileName = material.name;
              var fileNameWithoutExtention = materialFileName;

              if (materialFileName.lastIndexOf(".") != -1) {
                fileNameWithoutExtention = materialFileName.substring(0, materialFileName.lastIndexOf(".")).trim();
              }

              var fileExtention = "";

              if (materialFileName.lastIndexOf(".") != -1) {
                fileExtention = materialFileName.substring(materialFileName.lastIndexOf("."), materialFileName.length);
              }

              materialFileName = fileNameWithoutExtention + fileExtention;
            }

            if (materialFileList.filter(function (m) {
              return m.toLowerCase() == materialFileName.toLowerCase();
            }).length > 0) {
              uploadWarning.push("・".concat(materialFileName));
            }
          }

          if (uploadErrors.length > 0) {
            alert(uploadErrors.join("\n"));
            return;
          }

          if (uploadWarning.length > 0) {
            var message = intl.format(Errors.ConfirmFileExists);
            message = message.split('\\n').join('\n').concat(uploadWarning.join('\n'));
            var response = confirm(message);

            if (!response) {
              return;
            }
          }

          data.submit();
        },
        url: "SessionApi/UploadMaterial",
        type: "POST",
        replaceFileInput: false,
        singleFileUploads: false,
        timeout: 10800000,
        start: function start(_e) {
          if (_this4.props.isProcessing) {
            return;
          }

          setTimeout(function () {
            $("#overlay").fadeIn();
          });

          _this4.props.onChangeProcessing(true);

          _this4.props.onClearErrorMessages();
        },
        done: function done(_e, data) {
          var model = data.result;

          switch (model.ResultCode) {
            case ApiResultCodes.SessionStorageShortage:
            case ApiResultCodes.UnsupportedDataType:
            case ApiResultCodes.LengthError:
              _this4.props.onAppendErrorMessages(intl.format(Errors.FileUploadFailed));

              break;
          }

          _this4.props.onQueryDetail(model.Detail.SessionId);
        },
        fail: function fail(_e, data) {
          _this4.props.onAppendErrorMessages(intl.format(Errors.FileUploadFailed));

          if (_this4.props.selected == null) {
            setTimeout(function () {
              $("#overlay").fadeOut(300);
            }, 500);

            _this4.props.onChangeProcessing(false);
          } else {
            _this4.props.onQueryDetail(_this4.props.selected.SessionId);
          }
        }
      });
    }
    /**
     * ComponentがDOMツリーから削除された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var backButton = $("#menuReactBack");
      backButton.css("display", "none");
      backButton.off("click", this.onCloseFunction);
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "FileList"
      }, /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "Action",
        id: "Action",
        value: "DownloadMaterial"
      }), /*#__PURE__*/React.createElement("input", {
        type: "file",
        name: "UploadMaterial",
        id: "UploadMaterial",
        multiple: true
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        id: "sessionId",
        name: "sessionId",
        value: this.props.selected.SessionId
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        id: "updateDateTime",
        name: "updateDateTime",
        value: this.props.selected.Detail.UpdateDateTime
      }), this.props.selected.SelectedFileNames.map(function (x, i) {
        return /*#__PURE__*/React.createElement("input", {
          type: "hidden",
          key: "FileNameArray[" + i + "]",
          name: "FileNameArray[" + i + "]",
          value: x
        });
      }), /*#__PURE__*/React.createElement("div", {
        className: "mainContent"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader"
      }, this.props.selected.IsMyMeeting && !this.props.selected.IsHistory && /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__titleWrapper",
        title: this.props.selected.Detail.SessionName,
        onClick: this.props.onOpenModifySessionDetail.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__titleImg mainContentHeader__contImg mainContentHeader__contImg--title"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Edit.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__title"
      }, this.props.selected.Detail.SessionName)), (!this.props.selected.IsMyMeeting || this.props.selected.IsHistory) && /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__titleWrapper",
        title: this.props.selected.Detail.SessionName,
        onClick: this.props.onOpenReadonlySessionDetail.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__titleImg mainContentHeader__contImg mainContentHeader__contImg--title"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Edit.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__title"
      }, this.props.selected.Detail.SessionName)), !this.props.selected.IsHistory && /*#__PURE__*/React.createElement("div", {
        className: "mainContentHeader__btns"
      }, this.canDeleteMaterial() && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn imgAndTextBtn imgAndTextBtn",
        onClick: this.props.onDelete.bind(this, this.props.selected)
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg--mini"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Delete.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Action.DeleteSelectedFile))), !this.canDeleteMaterial() && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn imgAndTextBtn imgAndTextBtn--inactive",
        disabled: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg--mini"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Delete.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Action.DeleteSelectedFile))), /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: this.openQrCodeModal.bind(this)
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn imgAndTextBtn"
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Arrow_White_Grey.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Sessions.JoinFromQRCode)))))), this.props.errorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.props.errorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "grid"
      }, this.props.selected.Detail.MaterialList.length == 0 && /*#__PURE__*/React.createElement("div", {
        style: {
          zIndex: 80,
          width: "100%",
          height: "100%"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: "1.0rem",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          opacity: 0.5,
          padding: "15px"
        }
      }, /*#__PURE__*/React.createElement("div", null, intl.format(Sessions.NoFiles)))), this.props.selected.Detail.MaterialList.length > 0 && /*#__PURE__*/React.createElement("ul", {
        className: "content__list"
      }, this.props.selected.Detail.MaterialList.map(function (x) {
        return /*#__PURE__*/React.createElement("li", {
          key: x.MaterialFileName,
          className: "nav-item content__item"
        }, /*#__PURE__*/React.createElement("div", {
          className: "left"
        }, /*#__PURE__*/React.createElement("p", {
          className: "name"
        }, x.DisplayMaterialFileName), /*#__PURE__*/React.createElement("div", {
          className: "form-group"
        }, /*#__PURE__*/React.createElement("p", {
          className: "col-form-label"
        }, intl.format(Label.LastModifiedDatetime)), /*#__PURE__*/React.createElement("p", {
          className: "col-form-text"
        }, _this5.getFormattedDate(x)))), /*#__PURE__*/React.createElement("div", {
          className: "center"
        }, /*#__PURE__*/React.createElement("div", {
          className: "form-group"
        }, /*#__PURE__*/React.createElement("p", {
          className: "col-form-label"
        }, intl.format(Label.Size)), /*#__PURE__*/React.createElement("p", {
          className: "col-form-text"
        }, _this5.getReductionSize(x))), /*#__PURE__*/React.createElement("div", {
          className: "form-group"
        }, /*#__PURE__*/React.createElement("p", {
          className: "col-form-label"
        }, intl.format(Label.Situation)), /*#__PURE__*/React.createElement("p", {
          className: "col-form-text"
        }, _this5.getReductionStatusName(x)))), /*#__PURE__*/React.createElement("div", {
          className: "checkbox icheck-asbestos"
        }, /*#__PURE__*/React.createElement("input", {
          type: "checkbox",
          id: "check_" + x.MaterialFileName,
          name: "check_" + x.MaterialFileName,
          onChange: _this5.props.onChangeSelectedMaterial.bind(_this5, x),
          checked: _this5.props.selected.SelectedFileNames.some(function (m) {
            return m == x.MaterialFileName;
          })
        }), /*#__PURE__*/React.createElement("label", {
          htmlFor: "check_" + x.MaterialFileName
        }, " ")));
      }))), !this.props.selected.IsHistory && /*#__PURE__*/React.createElement("a", {
        href: "#",
        "data-toggle": "modal",
        "data-target": "#ResourceUploadModal_SmartPhone"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn addFile imgAndTextBtn"
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg--mini"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/add_icon_w.svg"
      })))), this.props.selected.IsHistory && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn addFile imgAndTextBtn imgAndTextBtn--inactive"
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg--mini"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/add_icon_w.svg"
      })))), /*#__PURE__*/React.createElement("div", {
        id: "modalArea"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "ResourceUploadModal_SmartPhone",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "40",
        height: "42",
        src: "/assets/img/upload_icon_gr.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(ResourceUpload.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        src: "/assets/img/Icon_Cancel_White.svg"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto"
      }, /*#__PURE__*/React.createElement("a", {
        className: "btn-fileupload",
        href: "#",
        onClick: this.fileupload.bind(this),
        "data-dismiss": "modal",
        title: ""
      }, intl.format(ResourceUpload.Title)))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }))))), this.state.QrCodeModalMode != SessionQrCodeModalComponentSmartphone.Mode.None && this.props.selected && /*#__PURE__*/React.createElement(SessionQrCodeModalComponentSmartphone["default"], {
        common: this.props.common,
        mode: this.state.QrCodeModalMode,
        roomId: this.props.selected.Detail.RoomId,
        qrCodeSessioniOSJoinUrl: this.props.selected.Detail.QRCodeSessioniOSJoinUrl,
        onHidden: this.hiddenQrCodeModal.bind(this)
      }));
    }
  }]);

  return FileListComponent;
}(React.Component);
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component3) {
  _inherits(MainComponent, _React$Component3);

  var _super3 = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this6;

    _classCallCheck(this, MainComponent);

    _this6 = _super3.call(this, props);
    var strOpenNavSessionIds = $.cookie("OpenNavSessionIds");
    _this6.openNavSessionIds = strOpenNavSessionIds == null ? [] : JSON.parse(strOpenNavSessionIds);
    _this6.state = {
      QueryIntervalId: 0,
      IsFilter: false,
      IsProcessing: false,
      Sessions: null,
      SessionDetailMode: SessionDetailMode.None,
      Selected: null,
      TargetFolderName: null,
      ModifiedSessionId: null,
      ModifiedSessionName: null,
      ModifiedStartDate: null,
      ModifiedStartTimeHours: null,
      ModifiedStartTimeMinutes: null,
      ModifiedEndDate: null,
      ModifiedEndTimeHours: null,
      ModifiedEndTimeMinutes: null,
      ModifiedUseState: null,
      ErrorMessages: []
    };

    _this6.clearTempValue();

    if (_this6.props.sessionId < 0) {
      Api.Query(false, function (data) {
        _this6.clearTempValue();

        _this6.setState({
          Sessions: data.Sessions,
          QueryIntervalId: window.setInterval(_this6.query.bind(_assertThisInitialized(_this6)), _this6.props.queryRefreshInterval)
        });
      });
    } else {
      Api.QueryDetail(_this6.props.sessionId, false, function (data) {
        _this6.updateTempValue(data.Detail);

        _this6.setState({
          Sessions: data.Sessions,
          Selected: {
            SessionId: _this6.props.sessionId,
            Detail: data.Detail,
            IsAllSelected: false,
            SelectedFileNames: [],
            IsMyMeeting: data.Detail.IsMyMeeting,
            IsOver: data.Detail.IsHistory,
            IsHistory: true
          },
          QueryIntervalId: window.setInterval(_this6.query.bind(_assertThisInitialized(_this6)), _this6.props.queryRefreshInterval)
        });
      });
    }

    return _this6;
  }

  _createClass(MainComponent, [{
    key: "clearTempValue",
    value: function clearTempValue() {
      materialFileList = [];
      totalMaterialFileSize = 0;
    }
  }, {
    key: "updateTempValue",
    value: function updateTempValue(detail) {
      if (!detail) return;
      materialFileList = detail.MaterialList.map(function (m) {
        return m.MaterialFileName;
      });
      totalMaterialFileSize = 0;

      for (var i = 0; i < detail.MaterialList.length; i++) {
        var material = detail.MaterialList[i];
        totalMaterialFileSize = totalMaterialFileSize + material.MaterialFileSize * 1024;
      }
    }
    /**
     * 検索を行います。
     */

  }, {
    key: "query",
    value: function query() {
      var _this7 = this;

      if (this.state.Selected == null) {
        Api.Query(true, function (data) {
          if (_this7.state.IsProcessing) return;

          _this7.clearTempValue();

          _this7.setState({
            Sessions: data.Sessions
          });
        });
      } else {
        Api.QueryDetail(this.state.Selected.SessionId, true, function (data) {
          if (_this7.state.IsProcessing) {
            return;
          }

          if (_this7.state.Selected == null || _this7.state.Selected.SessionId != data.Detail.SessionId) {
            return;
          }

          if (_this7.state.Selected != null && !_this7.state.Selected.IsHistory) {
            var saveIsAllSelected = _this7.state.Selected.IsAllSelected;
            var saveSelectedFileName = _this7.state.Selected.SelectedFileNames;

            _this7.updateTempValue(data.Detail);

            _this7.setState({
              Sessions: data.Sessions,
              Selected: {
                SessionId: data.Detail.SessionId,
                Detail: data.Detail,
                IsAllSelected: saveIsAllSelected,
                SelectedFileNames: [],
                IsMyMeeting: data.Detail.IsMyMeeting,
                IsOver: data.Detail.IsHistory,
                IsHistory: data.Detail.IsHistory
              }
            });

            for (var i = 0; i < data.Detail.MaterialList.length; i++) {
              var item = data.Detail.MaterialList[i];
              var checked = saveSelectedFileName.filter(function (x, _i) {
                return x == item.MaterialFileName;
              });

              if (checked.length > 0 && item.Status != ReductionStatuses.Wait && item.Status != ReductionStatuses.Processing) {
                _this7.changeSelectedMaterial(item);
              }
            }
          }
        });
      }
    }
    /**
     * 会議を選択します。
     *
     * @param session 会議情報
     * @param isMyMeeting My Meetingかどうかを表す値
     */

  }, {
    key: "selectSession",
    value: function selectSession(session) {
      var _this8 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.QueryDetail(session.SessionId, false, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        _this8.updateTempValue(data.Detail);

        _this8.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: {
            SessionId: session.SessionId,
            Detail: data.Detail,
            IsAllSelected: false,
            SelectedFileNames: [],
            IsMyMeeting: data.Detail.IsMyMeeting,
            IsOver: data.Detail.IsHistory,
            IsHistory: data.Detail.IsHistory
          },
          QueryIntervalId: window.setInterval(_this8.query.bind(_this8), _this8.props.queryRefreshInterval)
        });
      });
    }
    /**
     * 詳細検索
     */

  }, {
    key: "QueryDetail",
    value: function QueryDetail(sessionId) {
      var _this9 = this;

      Api.QueryDetail(sessionId, false, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        _this9.updateTempValue(data.Detail);

        _this9.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: {
            SessionId: data.Detail.SessionId,
            Detail: data.Detail,
            IsAllSelected: false,
            SelectedFileNames: [],
            IsMyMeeting: data.Detail.IsMyMeeting,
            IsOver: data.Detail.IsHistory,
            IsHistory: data.Detail.IsHistory
          },
          QueryIntervalId: window.setInterval(_this9.query.bind(_this9), _this9.props.queryRefreshInterval)
        });
      });
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.scrollTo(0, 0);
      this.props.common.bind();
    }
    /**
     * ComponentがDOMツリーから削除された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.QueryIntervalId != null) {
        clearInterval(this.state.QueryIntervalId);
      }
    }
    /**
     * 会議詳細を追加で起動します。
     */

  }, {
    key: "openAddSessionDetail",
    value: function openAddSessionDetail() {
      this.setState({
        IsProcessing: true,
        ErrorMessages: [],
        SessionDetailMode: SessionDetailMode.Add,
        TargetFolderName: this.getGuid(),
        ModifiedSessionId: null,
        ModifiedSessionName: null,
        ModifiedStartDate: null,
        ModifiedStartTimeHours: null,
        ModifiedStartTimeMinutes: null,
        ModifiedEndDate: null,
        ModifiedEndTimeHours: null,
        ModifiedEndTimeMinutes: null,
        ModifiedUseState: null
      });
    }
    /**
     * 会議詳細を編集で起動します。
     */

  }, {
    key: "openModifySessionDetail",
    value: function openModifySessionDetail() {
      this.setState({
        IsProcessing: true,
        ErrorMessages: [],
        SessionDetailMode: SessionDetailMode.Modify,
        TargetFolderName: this.state.Selected ? Utility.NullNumberToBlank(this.state.Selected.Detail.SessionId) : this.getGuid(),
        ModifiedSessionId: null,
        ModifiedSessionName: null,
        ModifiedStartDate: null,
        ModifiedStartTimeHours: null,
        ModifiedStartTimeMinutes: null,
        ModifiedEndDate: null,
        ModifiedEndTimeHours: null,
        ModifiedEndTimeMinutes: null,
        ModifiedUseState: null
      });
    }
    /**
     * 会議詳細を表示のみで起動します。
     */

  }, {
    key: "openReadonlySessionDetail",
    value: function openReadonlySessionDetail() {
      this.setState({
        IsProcessing: true,
        ErrorMessages: [],
        SessionDetailMode: SessionDetailMode.ReadOnly,
        TargetFolderName: this.state.Selected ? Utility.NullNumberToBlank(this.state.Selected.Detail.SessionId) : this.getGuid(),
        ModifiedSessionId: null
      });
    }
    /**
     * 削除処理を行います。
     *
     * @param selected 選択モデル
     */

  }, {
    key: "delete",
    value: function _delete(selected) {
      var _this10 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.DeleteMaterial(selected.SessionId, selected.SelectedFileNames, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this10.setDetail(data.Detail);

        _this10.updateTempValue(selected.Detail);

        _this10.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected,
          QueryIntervalId: window.setInterval(_this10.query.bind(_this10), _this10.props.queryRefreshInterval)
        });
      });
    }
    /**
     * 素材選択変更
     *
     * @param m 素材情報
     */

  }, {
    key: "changeSelectedMaterial",
    value: function changeSelectedMaterial(m) {
      if (!this.state.Selected) {
        throw Error();
      }

      var next = this.state.Selected.SelectedFileNames.filter(function (x, _i) {
        return x != m.MaterialFileName;
      });

      if (next.length == this.state.Selected.SelectedFileNames.length) {
        next.push(m.MaterialFileName);
      }

      var selected = this.state.Selected;
      selected.SelectedFileNames = next;
      this.setState({
        Selected: selected
      });
    }
    /**
     * 素材選択変更
     *
     * @param event 素材情報イベント
     */

  }, {
    key: "onRowSelected",
    value: function onRowSelected(event) {
      if (!this.state.Selected) {
        throw Error();
      }

      var selectedFileNames = [];
      var selectedRows = event.api.getSelectedRows();

      if (selectedRows.length > 0) {
        for (var i = 0; i < selectedRows.length; i++) {
          selectedFileNames.push(selectedRows[i].MaterialFileName);
        }
      }

      var selected = this.state.Selected;
      selected.SelectedFileNames = selectedFileNames;
      this.setState({
        Selected: selected
      });
    }
    /**
     * 詳細を設定します。
     *
     * @param detail 会議詳細モデル
     */

  }, {
    key: "setDetail",
    value: function setDetail(detail) {
      if (!this.state.Selected) {
        throw Error();
      }

      var selected = this.state.Selected;
      selected.Detail = detail;
      selected.IsAllSelected = false;
      selected.SelectedFileNames = [];
      return selected;
    }
    /**
     * 会議を登録します。
     *
     * @param sessionName 会議名
     * @param startDateTime 開始日
     * @param endDateTime 終了日
     * @param sceneModelName シーンモデル名
     * @param sceneImageName シーンイメージ名
     * @param targetFolderName ターゲットフォルダ名
     */

  }, {
    key: "entrySessionDetail",
    value: function entrySessionDetail(sessionName, startDateTime, endDateTime, sceneModelName, sceneImageName, targetFolderName) {
      var _this11 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.AddSession(sessionName, startDateTime, endDateTime, sceneModelName, sceneImageName, targetFolderName, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        _this11.updateTempValue(data.Detail);

        _this11.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: {
            SessionId: data.Detail.SessionId,
            Detail: data.Detail,
            IsMyMeeting: true,
            IsOver: data.Detail.IsHistory,
            IsHistory: false,
            IsAllSelected: false,
            SelectedFileNames: []
          },
          TargetFolderName: Utility.NullNumberToBlank(data.Detail.SessionId),
          QueryIntervalId: window.setInterval(_this11.query.bind(_this11), _this11.props.queryRefreshInterval)
        });
      });
    }
    /**
     * 会議を更新します。
     *
     * @param sessionId 会議ＩＤ
     * @param sessionName 会議名
     * @param startDateTime 開始日
     * @param endDateTime 終了日
     * @param sceneModelName シーンモデル名
     * @param sceneImageName シーンイメージ名
     * @param updateDateTime 更新日時
     */

  }, {
    key: "modifySessionDetailModel",
    value: function modifySessionDetailModel(sessionId, sessionName, startDateTime, endDateTime, sceneModelName, sceneImageName, updateDateTime) {
      var _this12 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      this.setState({
        IsProcessing: true,
        ErrorMessages: []
      });
      Api.ModifySession(sessionId, sessionName, startDateTime, endDateTime, sceneModelName, sceneImageName, updateDateTime, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);

        var selected = _this12.setDetail(data.Detail);

        _this12.updateTempValue(selected.Detail);

        _this12.setState({
          IsProcessing: false,
          Sessions: data.Sessions,
          Selected: selected,
          QueryIntervalId: window.setInterval(_this12.query.bind(_this12), _this12.props.queryRefreshInterval)
        });
      });
    }
    /**
     * ファイル一覧を閉じる処理を行います。
     */

  }, {
    key: "hiddenFileList",
    value: function hiddenFileList() {
      window.scrollTo(0, 0);
      this.setState({
        Selected: null
      });
    }
    /**
     * 会議詳細を閉じる処理を行います。
     */

  }, {
    key: "hiddenSessionDetail",
    value: function hiddenSessionDetail() {
      window.scrollTo(0, 0);
      this.setState({
        IsProcessing: false,
        SessionDetailMode: SessionDetailMode.None
      });
    }
    /**
     * 一意なID生成
     */

  }, {
    key: "getGuid",
    value: function getGuid() {
      var guid = "",
          i,
          random;

      for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;

        if (i == 8 || i == 12 || i == 16 || i == 20) {
          guid += "-";
        }

        guid += (i == 12 ? 4 : i == 16 ? random & 3 | 8 : random).toString(16);
      }

      return guid;
    }
    /**
     * 処理中かどうかを切り替えます。
     */

  }, {
    key: "changeProcessing",
    value: function changeProcessing(b) {
      this.setState({
        IsProcessing: b
      });
    }
    /**
     * エラーメッセージを追加します。
     */

  }, {
    key: "appendErrorMessages",
    value: function appendErrorMessages(s) {
      this.state.ErrorMessages.push(intl.format(Errors.FileUploadFailed));
      this.setState({
        ErrorMessages: this.state.ErrorMessages
      });
    }
    /**
     * エラーメッセージをクリアします。
     */

  }, {
    key: "clearErrorMessages",
    value: function clearErrorMessages() {
      this.setState({
        ErrorMessages: []
      });
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this13 = this,
          _this$state$Sessions,
          _this$state$Sessions$;

      return /*#__PURE__*/React.createElement("div", {
        className: "content-container"
      }, /*#__PURE__*/React.createElement("div", {
        id: "overlay"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cv-spinner"
      }, /*#__PURE__*/React.createElement("span", {
        className: "spinner"
      }))), this.state.SessionDetailMode == SessionDetailMode.None && !this.state.Selected && /*#__PURE__*/React.createElement("div", {
        className: "SessionList"
      }, /*#__PURE__*/React.createElement("div", {
        className: "main"
      }, /*#__PURE__*/React.createElement("div", {
        className: "main-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "main-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "mainIcon",
        width: "40",
        height: "42",
        src: "/assets/img/Icon_SessionManagement_Gray.svg"
      }), /*#__PURE__*/React.createElement("h1", null, intl.format(Session.Title)))), /*#__PURE__*/React.createElement("div", {
        className: "main__wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content__title"
      }, intl.format(Sessions.MyMeeting)), /*#__PURE__*/React.createElement("ul", {
        className: "content__list"
      }, this.state.Sessions != null && this.state.Sessions.MyMeetingList.map(function (x, _i) {
        return /*#__PURE__*/React.createElement("li", {
          key: x.SessionId,
          className: "nav-item content__item",
          onClick: _this13.selectSession.bind(_this13, x)
        }, /*#__PURE__*/React.createElement("img", {
          className: "cube",
          src: "/assets/img/whiteroomlogo_cube.svg"
        }), /*#__PURE__*/React.createElement("p", {
          className: "name"
        }, x.SessionName), /*#__PURE__*/React.createElement("img", {
          className: "arrow",
          src: "/assets/img/arrow_rigth.svg"
        }));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content__title"
      }, intl.format(Sessions.ShareMeeting)), /*#__PURE__*/React.createElement("ul", {
        className: "content__list"
      }, (_this$state$Sessions = this.state.Sessions) === null || _this$state$Sessions === void 0 ? void 0 : (_this$state$Sessions$ = _this$state$Sessions.ShareMeetingList) === null || _this$state$Sessions$ === void 0 ? void 0 : _this$state$Sessions$.map(function (x) {
        var _x$MeetingList;

        return ((_x$MeetingList = x.MeetingList) !== null && _x$MeetingList !== void 0 ? _x$MeetingList : []).map(function (y) {
          return /*#__PURE__*/React.createElement("li", {
            key: "share-".concat(x.Owner, "-").concat(y.SessionId),
            className: "nav-item content__item",
            onClick: _this13.selectSession.bind(_this13, y)
          }, /*#__PURE__*/React.createElement("img", {
            className: "cube",
            src: "/assets/img/whiteroomlogo_cube.svg"
          }), /*#__PURE__*/React.createElement("p", {
            className: "name"
          }, y.SessionName), /*#__PURE__*/React.createElement("img", {
            className: "arrow",
            src: "/assets/img/arrow_rigth.svg"
          }));
        });
      }))))), this.state.Sessions && this.state.Sessions.CurrentUserAuthorityId != 5 && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "addMeeting",
        onClick: this.openAddSessionDetail.bind(this)
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/add_icon_w.svg"
      }))), this.state.SessionDetailMode == SessionDetailMode.None && this.state.Sessions && this.state.Selected && /*#__PURE__*/React.createElement(FileListComponent, {
        selected: this.state.Selected,
        isProcessing: this.state.IsProcessing,
        common: this.props.common,
        sessionStorageSize: this.props.sessionStorageSize,
        avatarStorageSize: this.props.AvatarStorageSize,
        onHidden: this.hiddenFileList.bind(this),
        onOpenModifySessionDetail: this.openModifySessionDetail.bind(this),
        onOpenReadonlySessionDetail: this.openReadonlySessionDetail.bind(this),
        onDelete: this["delete"].bind(this),
        onRowSelected: this.onRowSelected.bind(this),
        onChangeProcessing: this.changeProcessing.bind(this),
        onAppendErrorMessages: this.appendErrorMessages.bind(this),
        onClearErrorMessages: this.clearErrorMessages.bind(this),
        onQueryDetail: this.QueryDetail.bind(this),
        onChangeSelectedMaterial: this.changeSelectedMaterial.bind(this),
        errorMessages: this.state.ErrorMessages,
        useOneDrive: this.props.useOneDrive,
        clientId: this.props.clientId
      }), this.state.SessionDetailMode == SessionDetailMode.Add && /*#__PURE__*/React.createElement(SessionDetailComponent, {
        mode: this.state.SessionDetailMode,
        sessionId: null,
        sessionName: this.state.ModifiedSessionName ? this.state.ModifiedSessionName : "",
        startDateTime: null,
        endDateTime: null,
        startDate: this.state.ModifiedStartDate,
        startTimeHours: this.state.ModifiedStartTimeHours,
        startTimeMinutes: this.state.ModifiedStartTimeMinutes,
        endDate: this.state.ModifiedEndDate,
        endTimeHours: this.state.ModifiedEndTimeHours,
        endTimeMinutes: this.state.ModifiedEndTimeMinutes,
        defaultSceneModelName: this.props.defaultSceneModelName,
        defaultSceneImageName: this.props.defaultSceneImageName,
        sceneModelName: this.props.defaultSceneModelName,
        sceneImageName: this.props.defaultSceneImageName,
        targetFolderName: Utility.NullStringToBlank(this.state.TargetFolderName),
        isHistory: false,
        updateDateTime: null,
        onEntry: this.entrySessionDetail.bind(this),
        onModify: this.modifySessionDetailModel.bind(this),
        onHidden: this.hiddenSessionDetail.bind(this)
      }), (this.state.SessionDetailMode == SessionDetailMode.Modify || this.state.SessionDetailMode == SessionDetailMode.ReadOnly) && /*#__PURE__*/React.createElement(SessionDetailComponent, {
        mode: this.state.SessionDetailMode,
        sessionId: this.state.ModifiedSessionId ? this.state.ModifiedSessionId : this.state.Selected ? this.state.Selected.SessionId : null,
        sessionName: this.state.ModifiedSessionName ? this.state.ModifiedSessionName : this.state.Selected ? this.state.Selected.Detail.SessionName : "",
        startDateTime: this.state.Selected ? this.state.Selected.Detail.StartDateTime : null,
        endDateTime: this.state.Selected ? this.state.Selected.Detail.EndDateTime : null,
        startDate: this.state.ModifiedStartDate,
        startTimeHours: this.state.ModifiedStartTimeHours,
        startTimeMinutes: this.state.ModifiedStartTimeMinutes,
        endDate: this.state.ModifiedEndDate,
        endTimeHours: this.state.ModifiedEndTimeHours,
        endTimeMinutes: this.state.ModifiedEndTimeMinutes,
        defaultSceneModelName: this.props.defaultSceneModelName,
        defaultSceneImageName: this.props.defaultSceneImageName,
        sceneModelName: this.state.Selected ? this.state.Selected.Detail.SceneModelName : this.props.defaultSceneModelName,
        sceneImageName: this.state.Selected ? this.state.Selected.Detail.SceneImageName : this.props.defaultSceneImageName,
        targetFolderName: Utility.NullStringToBlank(this.state.TargetFolderName),
        isHistory: false,
        updateDateTime: this.state.Selected ? this.state.Selected.Detail.UpdateDateTime : null,
        onEntry: this.entrySessionDetail.bind(this),
        onModify: this.modifySessionDetailModel.bind(this),
        onHidden: this.hiddenSessionDetail.bind(this)
      }));
    }
  }]);

  return MainComponent;
}(React.Component);
/**
 * レンダラー
 *
 * @param el バインド対象
 * @param common 共通
 * @param queryRefreshInterval 検索リフレッシュインターバル
 * @param defaultCenterLatitude 地図 初期表示：中心：緯度
 * @param defaultCenterLongitude 地図 初期表示：中心：経度
 * @param defaultSelectLatitude 地図 初期選択座標：緯度
 * @param defaultSelectLongitude 地図 初期選択座標：経度
 * @param defaultSelectLevel 地図 初期表示範囲
 * @param defaultMapZoom 地図 初期倍率
 * @param rectDistance 地形 地図 Pinから矩形領域までの半径距離（km） 演算された円に接する矩形を表示する
 * @param sessionStorageSize １セッションが管理できる素材のトータルサイズ
 * @param avatarStorageSize アバターのサイズ
 * @param sessionId 会議ID
 * @param userId ユーザーID
 * @param mode モード
 * @param pageSize ページサイズ
 * @param defaultSceneModelName シーンのデフォルトモデル名
 * @param defaultSceneImageName シーンのデフォルトイメージ名
 * @param useOneDrive OneDriveを使用可能かどうか
 * @param clientId クライアントID
 */


export default function (el, common, queryRefreshInterval, defaultCenterLatitude, defaultCenterLongitude, defaultSelectLatitude, defaultSelectLongitude, defaultSelectLevel, defaultMapZoom, rectDistance, sessionStorageSize, avatarStorageSize, sessionId, userId, mode, pageSize, defaultSceneModelName, defaultSceneImageName, useOneDrive, clientId) {
  ReactDOM.render( /*#__PURE__*/React.createElement(MainComponent, {
    common: common,
    queryRefreshInterval: queryRefreshInterval,
    defaultCenterLatitude: defaultCenterLatitude,
    defaultCenterLongitude: defaultCenterLongitude,
    defaultSelectLatitude: defaultSelectLatitude,
    defaultSelectLongitude: defaultSelectLongitude,
    defaultSelectLevel: defaultSelectLevel,
    defaultMapZoom: defaultMapZoom,
    rectDistance: rectDistance,
    sessionStorageSize: sessionStorageSize,
    AvatarStorageSize: avatarStorageSize,
    sessionId: sessionId,
    userId: userId,
    mode: mode,
    pageSize: pageSize,
    defaultSceneModelName: defaultSceneModelName,
    defaultSceneImageName: defaultSceneImageName,
    useOneDrive: useOneDrive,
    clientId: clientId
  }), el);
}